/* eslint-disable import/no-anonymous-default-export */
export default {
    validationCounter: 0,
    displayBankValidationMessage: false,
    disableEFTOption: false
  };
  